import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import * as fromAfbGraphqlApi from '../../../afb-graphql-api/reducers';
import {select, Store} from '@ngrx/store';
import {Observable, Subscription} from 'rxjs';
import {PostLoginRequest} from '../../../afb-api/models/token';
import {skip} from 'rxjs/operators';
import {Login} from '../../../afb-graphql-api/actions/auth.actions';

@Component({
  selector: 'awair-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit, OnDestroy {

  isLoggingIn$: Observable<boolean> = this.afbGraphqlApiStore.pipe(select(fromAfbGraphqlApi.isLoginLoading));
  isLoggedIn$: Observable<boolean> = this.afbGraphqlApiStore.pipe(select(fromAfbGraphqlApi.isLoginLoaded));
  errorMessage$: Observable<string> = this.afbGraphqlApiStore.pipe(
    select(fromAfbGraphqlApi.loginError),
    // Need to skip the default error message to avoid it from showing on init
    // Happens when this component is revisited
    skip(1)
  );

  isLoggedInSubscription: Subscription;

  constructor(private router: Router,
              private afbGraphqlApiStore: Store<fromAfbGraphqlApi.State>) {
  }

  ngOnInit() {
    this.isLoggedInSubscription = this.isLoggedIn$.subscribe((isLoggedIn: boolean) => {
      if (isLoggedIn) {
        this.router.navigate(['/org']);
      }
    });
  }

  ngOnDestroy() {
    if (this.isLoggedInSubscription) {
      this.isLoggedInSubscription.unsubscribe();
    }
  }

  login({email, password}: PostLoginRequest): void {
    this.afbGraphqlApiStore.dispatch(new Login({
      password,
      email: email.toLowerCase()
    }));
  }
}


